import { PlayerBrowserSupport } from "./player_browser_support";
import { PlayerEnvironment } from "./player_environment";
import AhoyAdapter from "./adapters/ahoy_adapter";
import VideoAdapter from "./adapters/video_adapter";
import MSEAdapter from "./adapters/mse_adapter";
import VideoJsAdapter from "./adapters/videojs_adapter";

export class PlayerAhoyCommonEvent {
  static env(){
    return Object.assign({
      player_name: "videojs",
      player_version: VideoJsAdapter.version()
    },PlayerEnvironment.currentEnv());
  }

  static autoplayAttribute(autoplay){
    return {
      autoplay: autoplay.value(),
      autoplay_data: autoplay.data(),
    };
  }

  static globalAppendData(){
    return Object.assign({}, this._globalAppendData) || {};
  }

  static sendEvent(type, properties, prefix="PLAYBACK::"){
    var completeProperties = Object.assign(properties, this.env());
    Object.assign(completeProperties, this.globalAppendData());
    AhoyAdapter.track(prefix + type, completeProperties);
  }

  static sendPlatformSupportEvent(options = {}) {
    const properties = Object.assign({
      supported: PlayerBrowserSupport.isSupported(),
      video: VideoAdapter.isSupported(),
      h264: VideoAdapter.isSupportH264Encoding(),
      mse: MSEAdapter.isSupported(),
      mse_h264: VideoAdapter.isSupportMSEH264Encoding(),
      webm_vp8: VideoAdapter.isSupportWebmVP8Encoding(),
      mse_vp9: VideoAdapter.isSupportMSEVP9Encoding(),
      vjs_html5: VideoJsAdapter.isHtml5Supported(),
      vjs_mpegurl: VideoJsAdapter.isMpegUrlSupported(),
      type: options.type,
      play_uuid: options.play_uuid
    }, this.env());

    this.sendEvent('PLATFORM::SUPPORT', properties);
  }

  static sendPlaybackBitrateShow(play_uuid) {
    const props = Object.assign({
      play_uuid
    }, this.env());

    this.sendEvent('BITRATE::SHOW', props);
  }

  static sendBitrate({ play_uuid, action, quality, bandwidth, network_type, content_type }) {
    const props = Object.assign({
      play_uuid,
      action,
      quality,
      bandwidth,
      network_type,
      content_type
    }, this.env());

    this.sendEvent('BITRATE', props);
  }

  static sendAdBuffer(options) {
    const properties = Object.assign(options, this.env());

    this.sendEvent('AD::BUFFER', properties);
  }
}
